// extracted by mini-css-extract-plugin
module.exports = {"timerDiv":"Timer_timerDiv__3h6lW","timerMessage":"Timer_timerMessage__2_wcc"};